import React, { FC, ReactNode } from 'react';
import { Box, Typography } from '@mui/material';
import { StubContainer } from './Stub.style';

type ValueProps = {
  title: string;
  description?: string;
  subDescription?: string;
  img: string;
  subtitle?: string;
  imageAlt?: string;
};

type Props = {
  value: ValueProps;
  isBoltSubtitleText?: boolean;
  renderButtonComponent?: () => ReactNode;
};

const Stub: FC<Props> = ({ value, isBoltSubtitleText = true, renderButtonComponent }) => {
  return (
    <StubContainer>
      <Typography variant="h1">{value.title}</Typography>

      <Typography
        sx={{
          color: 'rgba(0, 0, 0, 0.6)',
          margin: '16px 0',
          maxWidth: '592px',
        }}
        variant="large"
      >
        {value.description}
      </Typography>

      <Box sx={{ width: '100%', maxWidth: { sm: '400px', xs: '350px' } }}>
        <img src={value.img} alt={value.imageAlt} width="100%" />
      </Box>
      <Typography
        sx={(theme) => ({
          width: '100%',
          maxWidth: '592px',
          margin: '16px 0 16px 0',
          color: isBoltSubtitleText ? 'initial' : theme.palette.case.neutral.n700,
        })}
        variant={`${isBoltSubtitleText ? 'h3' : 'large'}`}
      >
        {value.subtitle ? value.subtitle : value.subDescription}
      </Typography>
      {renderButtonComponent && renderButtonComponent()}
    </StubContainer>
  );
};

export default Stub;
